<template>
    <div class="container page">
        <van-nav-bar :title="$t('page.setting.navTitle')" class="nav-bar">
            <template #left>
                <van-icon name="arrow-left" color="#fff" @click="back()" />
            </template>
        </van-nav-bar>
        <div class="items">
            <div class="item van-hairline--bottom" @click="showLangSheet = true">
                <div class="left">{{ $t('page.setting.language') }}</div>
                <div class="right">
                    <span class="desc">{{ currentLangName }}</span>
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="item van-hairline--bottom" @click="toInfomation()">
                <div class="left">{{ $t('page.setting.basicInfoSetting') }}</div>
                <van-icon name="arrow" />
            </div>
            <div class="item van-hairline--bottom" @click="toLoginPassword()">
                <div class="left">{{ $t('page.setting.loginPassword') }}</div>
                <van-icon name="arrow" />
            </div>
            <div class="item van-hairline--bottom" @click="toPayPassword()">
                <div class="left">{{ $t('page.setting.payPassword') }}</div>
                <div class="right">
                    <span class="desc">{{ this.userInfo.paypassword ? $t('page.setting.payPasswordSet') : $t('page.setting.payPasswordUnset') }}</span>
                    <van-icon name="arrow" />
                </div>
            </div>
        </div>
        <van-button class="sign-out" type="primary" size="normal" @click="loginout()">{{ $t('page.setting.logout') }}</van-button>
		<van-popup v-model="showLangSheet" position="bottom" round :style="{ height: '50%' }">
			<div class="popupbox">
				<div class="title">
				    <van-icon @click="showLangSheet=false" name="cross" />
				    <div class="text">{{ $t('page.setting.language') }}</div>
				    <div class="btnok" > </div>
					
				</div>
				<div class="content">
					<div class="contentitem"
						 v-for="(item,index) in langActions" :key="index"
						 @click="onSelectLang( item )"
					 > 
						<div>{{item.name}}</div>
					</div>
				</div>
			</div>
		</van-popup>
		

    </div>
</template>

<script>
    import { setLang, LANG_OPTIONS } from '@/locales'
    export default {
        data() {
            return {
                userInfo: {},
                showLangSheet: false,
                langActions: LANG_OPTIONS,
            };
        },
        computed: {
            currentLangName() {
                const found = LANG_OPTIONS.find(o => o.lang === this.$i18n.locale)
                return found ? found.name : ''
            }
        },
        methods: {
            back() {
                return window.history.back();
            },
            toPayPassword() {
                // 既有 bug 修复：原代码用中文 "未设置" 字符串比对越英混搭赋值，永远不匹配
                // 现统一为布尔值：有 paypassword=已设，无=未设
                if (this.userInfo.paypassword) {
                    this.$toast(this.$t('page.setting.payPasswordAlreadySet'));
                } else {
                    this.$router.push({ path: '/SetPayPassword' });
                }
            },
            toLoginPassword() {
                this.$router.push({ path: '/SetLoginPassword' });
            },
            toInfomation() {
                this.$router.push({ path: '/Infomation' });
            },
            loginout() {
                localStorage.clear()
                this.$router.push({ path: '/Mine' });
            },
            toServicePage() {
                this.$router.push("ServicePage");
            },
            onSelectLang(item) {
                setLang(item.lang);
                this.showLangSheet = false;
                // setTimeout(() => location.reload(), 200);
            },
            getUserInfo() {
                this.$http({
                    method: 'get',
                    url: 'user_info'
                }).then(res => {
                    if (res.code === 200) {
                        this.userInfo = res.data;
                        // 既有 bug 修复：原代码赋值 "Đã đặt"/"Chưa set" 中越英混搭
                        // 现统一为布尔值，文案由 i18n 翻译
                        this.userInfo.paypassword = !!res.data.paypassword;
                    } else if (res.code === 401) {
                        this.$toast(res.msg);
                    }
                })
            }
        },
        created() {
            if (!localStorage.getItem('token')) {
                this.$router.push({ path: '/Login' })
            } else {
                this.getUserInfo();
            }
        }
    };
</script>

<style lang='less' scoped>
    @import "../../assets/css/base.css";

    .container .items {
        background-color: #fff;
        font-size: 30px;
        color: #000;
        padding: 0 25px;
    }

        .container .items .item {
            padding: 30px 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            border-bottom-width: 10px;
        }

        .container .items .van-hairline--bottom::after {
            border-bottom-width: 3px;
        }

    .container .sign-out {
        margin: 500px 20px 0;
        height: 100px;
        line-height: 100px;
        border-radius: 50px;
        color: #fff;
        font-size: 40px;
        font-weight: bolder;
        border: none;
        background:linear-gradient(135deg, #8e44ad, #3498db);
    }

    .container .item .desc {
        font-size: 30px;
        font-weight: 700;
        color: #979799;
    }

    .container .item .right {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
</style>
